import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card, DatePicker, Select } from "antd";
import { isValidValue, setFormFieldValue } from "../../../../../helpers/FormHelper";
import moment from "moment";
import { replaceAlbanianChars } from "../../../../../helpers/MainHelper";



const Search = ({ dispatch, initialFilters, countries, searchLoading }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            country: setFormFieldValue(initialFilters?.country),
            emigrant_city: setFormFieldValue(initialFilters?.city),
            origin_city: setFormFieldValue(initialFilters?.city_albania),
            name: setFormFieldValue(initialFilters?.name),
            surname: setFormFieldValue(initialFilters?.surname),
            phone: setFormFieldValue(initialFilters?.phone),
            referrer: setFormFieldValue(initialFilters?.referues_name),
            fromDate: isValidValue(initialFilters?.from_date) ? moment(initialFilters?.from_date) : null,
            toDate: isValidValue(initialFilters?.to_date) ? moment(initialFilters?.to_date) : null,
        });
    }, [form, initialFilters]);


    const searchClickHandler = () => {
        const { country, emigrant_city, origin_city, name, surname, phone, referrer, fromDate, toDate } = form.getFieldsValue();
        const isValidFromDate = isValidValue(fromDate);
        const isValidToDate = isValidValue(toDate);

        const requestFilters = {
            name: setFormFieldValue(name),
            surname: setFormFieldValue(surname),
            phone: setFormFieldValue(phone),
            country: setFormFieldValue(country),
            city: setFormFieldValue(emigrant_city),
            city_albania: setFormFieldValue(origin_city),
            referues_name: setFormFieldValue(referrer),
            from_date: isValidFromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
            to_date: isValidToDate ? moment(toDate).format('YYYY-MM-DD') : null
        };

        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card bodyStyle={{ paddingBottom: "0" }}>
                    <Form
                        layout="vertical"
                        form={form}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={24} align="bottom">
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="country" label="Shteti:">
                                    <Select
                                        className="w-100"
                                        placeholder="-Zgjidhni shtetin-"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => replaceAlbanianChars(option.children).indexOf(replaceAlbanianChars(input)) >= 0}
                                        allowClear
                                    >
                                        {countries?.map((type) => (
                                            <Select.Option key={type?.id} value={type?.id}>
                                                {type?.country_name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="emigrant_city" label="Qyteti i emigrimit:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="surname"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="origin_city" label="Qyteti i origjinës:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="phone"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}></Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="name" label="Emri:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="name"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="surname" label="Mbiemri:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="surname"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="phone" label="Telefoni:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="phone"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}></Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="referrer" label="Referuar nga:">
                                    <Input
                                        prefix={<SearchOutlined />}
                                        name="referrer"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="fromDate" label="Nga data:">
                                    <DatePicker
                                        className="w-100"
                                        placeholder="-Zgjidhni datën-"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                                <Form.Item name="toDate" label="Në data:">
                                    <DatePicker
                                        className="w-100"
                                        placeholder="-Zgjidhni datën-"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={2} lg={2} md={24} sm={24} xs={24}></Col>
                            <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-center">
                                <Form.Item>
                                    <Button
                                        block
                                        type="primary"
                                        size="medium"
                                        loading={searchLoading}
                                        icon={<SearchOutlined />}
                                        onClick={() => searchClickHandler()}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};


export default Search;